import React from 'react';
import { motion } from 'framer-motion';
import { AlertIcon } from './icons';
export function PainAgitation() {
  return <section className="py-24 bg-brand-bg-light relative overflow-hidden" data-id="element-204">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-red to-transparent opacity-50" data-id="element-205"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-207">
          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-208">
            <AlertIcon className="w-10 h-10 text-brand-red" data-id="element-209" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-210">
              El Error Que Cometen Miles de Propietarios
            </h2>
          </div>

          <div className="space-y-8 text-lg sm:text-xl text-gray-300" data-id="element-211">
            <p data-id="element-212">
              Todos los años, miles de propietarios en Maryland, DC y Virginia
              cometen el mismo error.
            </p>
            <p data-id="element-213">Ven el daño. Saben que hay que arreglarlo. Y deciden esperar.</p>

            <div className="bg-brand-bg-dark p-6 rounded-lg border border-gray-800 space-y-4 my-8 shadow-inner" data-id="element-214">
              <p className="italic text-gray-400" data-id="element-215">"Lo hago el próximo mes."</p>
              <p className="italic text-gray-400" data-id="element-216">"Cuando tenga más tiempo."</p>
              <p className="italic text-gray-400" data-id="element-217">
                "Cuando consiga a alguien de confianza."
              </p>
            </div>

            <p data-id="element-218">
              Y mientras esperan... ese pequeño crack en el concreto se vuelve
              una grieta. Esa gotera en el techo destruye el drywall. Ese fence
              inclinado termina en el piso.
            </p>

            <div className="bg-brand-red/5 border-l-4 border-brand-red p-6 my-10" data-id="element-219">
              <p className="text-2xl sm:text-3xl font-heading font-bold text-white m-0" data-id="element-220">
                Lo que costaba <span className="text-brand-gold" data-id="element-221">$300</span>{' '}
                arreglar en enero, ahora cuesta{' '}
                <span className="text-brand-red" data-id="element-222">$1,200</span> en junio.
              </p>
            </div>

            <p data-id="element-223">
              Y encima de eso — encontraste a alguien, le pagaste el depósito,
              y... desapareció. O hizo el trabajo a medias. O simplemente hizo
              lo mínimo para cobrar y irse.
            </p>

            <p className="font-medium text-white border-b border-gray-800 pb-4 inline-block" data-id="element-224">
              Sabemos que ya pasaste por eso. La mayoría de la gente que nos
              llama ha pasado por eso.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}